import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { capture } from "@orb-labs/orby-react";
import { NavigationEvents } from "@orb-labs/orby-react/bullrun";

const ROUTE_SCREEN_MAP: Record<string, string> = {
  "/": "discover",
  "/discover": "discover",
  "/tokens": "token_list",
  "/perps": "perp_list",
  "/predictions": "predictions",
  "/watchlist": "watchlist",
  "/account": "account",
  "/signal": "signal",
  "/activity": "activity",
  "/settings": "settings",
  "/settings/account": "settings_account",
  "/settings/notifications": "settings_notifications",
  "/welcome": "landing",
  "/track": "track",
  "/terms": "terms",
  "/privacy": "privacy",
};

function resolveScreenName(pathname: string): string {
  if (ROUTE_SCREEN_MAP[pathname]) return ROUTE_SCREEN_MAP[pathname];
  if (pathname.startsWith("/token/")) return "token_detail";
  if (pathname.startsWith("/perps/")) return "perp_detail";
  if (pathname.startsWith("/prediction/")) return "prediction_detail";
  if (pathname.startsWith("/invite/")) return "deep_link_fallback";
  if (pathname === "/join" || pathname === "/search") return "deep_link_fallback";
  return pathname;
}

/**
 * Fires a `nav_screen_view` event whenever the route changes.
 * Place this once in the app tree, inside the Router context.
 */
export function useScreenView(): void {
  const { pathname } = useLocation();
  const previousRef = useRef<string | undefined>(undefined);

  useEffect(() => {
    const screenName = resolveScreenName(pathname);
    capture(NavigationEvents.SCREEN_VIEW, {
      screen_name: screenName,
      previous_screen: previousRef.current,
    });
    previousRef.current = screenName;
  }, [pathname]);
}
